import React, { PureComponent } from 'react';

import { AudioSettingsButton, VideoSettingsButton } from '../../../../toolbox/components/web';
import { VideoBackgroundButton } from '../../../../virtual-background';
import { checkBlurSupport } from '../../../../virtual-background/functions';

import Preview from './Preview';

import { PreMeetingScreen, _connect } from './PreMeetingScreen';
import { Dialog } from '../../../dialog';

declare var APP:object;

export default class RPC_PreMeetingScreen extends PreMeetingScreen {

    constructor(props) {
        super(props);
        this.state = {
            permissions: {
                audio: null,
                video: null
            },
            _p: {}
        };
        this.dismiss = this.dismiss.bind(this);
    }

    async devices() {
        try {
            const mic = await navigator.permissions.query({ name: 'microphone' });
            const camera = await navigator.permissions.query({ name: 'camera' });
            mic.onchange = () => {
                this.setState({ _p : {} })
            }
            camera.onchange = () => {
                this.setState({ _p : {} })
            }
            return {
                mic: mic.state,
                camera: camera.state
            }
        } catch ($e) {
            return {
                mic: '',
                camera: ''
            }
        }
    }

    componentDidMount() {
        var lobby = document.getElementById('lobby-screen');
        var el = lobby.firstChild;
        var ct = lobby.lastChild;
        console.log('el.offsetWidth', el.offsetWidth);
        console.log('el.offsetHeight', el.offsetHeight);
        if(el.offsetWidth/el.offsetHeight < 16/9) {
            var height = el.offsetWidth * 9/16;
            el.style.height = height + 'px';
            el.style.width = '100%';
            el.style.flex = 'none';
            ct.style.flex = 1;
        } else {
            var width = el.offsetHeight * 16/9;
            el.style.width = width + 'px';
            el.style.flex = 'none';
            ct.style.flex = 1;
        }

        window.onresize = function() {
            document.getElementById("lobby-screen").children[0].style.height = 'auto';
            var lobby = document.getElementById('lobby-screen');
            var el = lobby.firstChild;
            var ct = lobby.lastChild;
            console.log('el.offsetWidth', el.offsetWidth);
            console.log('el.offsetHeight', el.offsetHeight);
            if(el.offsetWidth/el.offsetHeight < 16/9) {
                var height = el.offsetWidth * 9/16;
                el.style.height = height + 'px';
                el.style.width = '100%';
                el.style.flex = 'none';
                ct.style.flex = 1;
            } else {
                var width = el.offsetHeight * 16/9;
                el.style.width = width + 'px';
                el.style.flex = 'none';
                ct.style.flex = 1;
            }
        }

        this.devices().then((_p) => {
            this.setState({
                _p
            })
        })
        // const script = document.createElement('script');
        // script.type = 'text/javascript';
        // script.async = true;
        // script.innerHTML = "window.__lc_criteo = window.__lc_criteo || {};window.__lc = window.__lc || {};window.__lc.license = 8577026;$(document).ready(function(){setTimeout(function(){var lc_criteo = document.createElement('script'); lc_criteo.type = 'text/javascript'; lc_criteo.async = true;lc_criteo.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'static.criteo.net/js/ld/ld.js';var c_source = document.getElementsByTagName('script')[0]; c_source.parentNode.insertBefore(lc_criteo, c_source);window.criteo_q = window.criteo_q || []; window.criteo_q.push( { event: 'setAccount', account: 35551}, { event: 'setSiteType', type: /iPad/.test(navigator.userAgent)?'t':/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)?'m' :'d'}, { event: 'viewHome'});";
        // document.body.appendChild(script);
    }

    componentDidUpdate() {
        const { permissions } = APP.store.getState()['features/base/devices'];
        if(JSON.stringify(this.state.permissions) != JSON.stringify(permissions)) {
            this.setState({ permissions });
        }
    }

    dismiss() {
        this.setState({
            _p: {}
        })
    }

    render() {
        const { name, showAvatar, showConferenceInfo, title, videoMuted, videoTrack } = this.props;
        const { permissions, _p } = this.state;
        return (
            <div
                className = 'premeeting-screen'
                id = 'lobby-screen'>
                {
                    (_p.mic == "prompt") && <Dialog
                        cancelKey = { 'Dismiss' }
                        submitDisabled = { true }
                        isModal = { false }
                        titleKey = 'keyboardShortcuts.keyboardShortcuts'
                        width = 'medium'
                        onCancel = { this.dismiss }
                        customHeader = { () => <></> }>
                        <div>
                            <h3 style={{ margin: '30px 0' }}>Allow RemotePC to use your camera and microphone</h3>
                            <p style={{ textAlign: 'justify' }}>RemotePC Meeting needs access to your camera and microphone so that other participants can see and hear you. RemotePC Meeting will ask you to confirm this decision on each and every browser and computer that you use.</p>
                        </div>
                    </Dialog>
                }
                {
                    (_p.mic == "denied" || _p.camera == "denied") && <Dialog
                        cancelKey = { 'Dismiss' }
                        submitDisabled = { true }
                        isModal = { false }
                        titleKey = 'keyboardShortcuts.keyboardShortcuts'
                        width = 'medium'
                        onCancel = { this.dismiss }
                        customHeader = { () => <></> }>
                        <div>
                            <h3 style={{ margin: '30px 0' }}>Camera and microphone are blocked</h3>
                            <p>RemotePC Meeting requires access to your camera and microphone. Click the camera blocked icon <img style={{ position: 'relative', top: '4px' }} src="https://ssl.gstatic.com/meet/ic_blocked_camera_dark_f401bc8ec538ede48315b75286c1511b.svg" /> in your browser's address bar.</p>
                        </div>
                    </Dialog>
                }
                <div>
                    <Preview
                        videoMuted = { videoMuted }
                        videoTrack = { videoTrack } />
                    {/* {<div className = 'preview-overlay' />} */}
                    { !permissions.audio && !permissions.video && <div className="device-info">
                        <h3>Your camera and microphone are blocked<br/><small>RemotePC Meeting requires access to your camera and microphone. <br/>Click the camera blocked icon <img src="https://ssl.gstatic.com/meet/ic_blocked_camera_dark_f401bc8ec538ede48315b75286c1511b.svg" style={{margin: "0 6px"}} /> in your browser's address bar.</small></h3>
                    </div> }
                    { permissions.audio && !permissions.video && <div className="device-info">
                        <h3>Your camera is blocked<br/><small>RemotePC Meeting requires access to your camera. <br/>Click the camera blocked icon <img src="https://ssl.gstatic.com/meet/ic_blocked_camera_dark_f401bc8ec538ede48315b75286c1511b.svg" style={{margin: "0 6px"}} /> in your browser's address bar.</small></h3>
                    </div> }
                    <div className = 'media-btn-container'>
                        <div className = 'toolbox-content'>
                            <div className = 'toolbox-content-items'>
                                <AudioSettingsButton visible = { true } />
                                <VideoSettingsButton visible = { true } />
                                <VideoBackgroundButton visible = { checkBlurSupport() } />
                            </div>
                        </div>
                    </div>
                </div>
                <div className = 'content'>
                    { this.props.children }
                </div>
            </div>
        )
    }
}